import { Controller } from "@hotwired/stimulus"

// Enforces "from" date <= "to" date: updates min/max on the other field when one changes,
// and blocks form submit when the range is invalid, showing an error message.
export default class extends Controller {
  static targets = ["fromInput", "toInput", "errorMessage"]
  static values = { errorMessage: String }

  connect() {
    this.syncConstraints()
  }

  fromInputChanged() {
    if (this.hasToInputTarget) {
      this.toInputTarget.min = this.fromInputTarget.value || ""
    }
    this.hideError()
  }

  toInputChanged() {
    if (this.hasFromInputTarget) {
      this.fromInputTarget.max = this.toInputTarget.value || ""
    }
    this.hideError()
  }

  validate(event) {
    const from = this.fromInputTarget?.value
    const to = this.toInputTarget?.value
    if (from && to && from > to) {
      event.preventDefault()
      this.showError()
      return false
    }
    return true
  }

  syncConstraints() {
    if (this.hasFromInputTarget && this.fromInputTarget.value && this.hasToInputTarget) {
      this.toInputTarget.min = this.fromInputTarget.value
    }
    if (this.hasToInputTarget && this.toInputTarget.value && this.hasFromInputTarget) {
      this.fromInputTarget.max = this.toInputTarget.value
    }
  }

  showError() {
    if (this.hasErrorMessageTarget && this.errorMessageValue) {
      this.errorMessageTarget.textContent = this.errorMessageValue
      this.errorMessageTarget.hidden = false
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = ""
      this.errorMessageTarget.hidden = true
    }
  }
}
